module.exports = __webpack_public_path__ + "static/img/trebuchet_ms.3f683fb.svg";